import { z } from 'zod';
import { EMAIL_PATTERN } from './policies/email.js';
import { PHONE_PATTERN } from './policies/phone.js';
/**
 * Input schema for `PATCH /organizations/:slug/settings/billing`.
 *
 * All 5 fields are nullable — callers may clear any field individually.
 * Email and phone fields are validated against shared policy patterns
 * (EMAIL_PATTERN / PHONE_PATTERN) when non-null.
 * Free-text fields (legalCompanyName, legalOwnerName, billingAddress)
 * accept any string including injection-shaped values — sanitisation
 * happens downstream in the domain VO.
 *
 * `.strict()` rejects extra keys so that callers cannot smuggle
 * additional fields past the validation boundary.
 */
export const updateBillingInfoSchema = z
    .object({
    legalCompanyName: z.string().nullable(),
    legalOwnerName: z.string().nullable(),
    billingAddress: z.string().nullable(),
    billingEmail: z.string().regex(EMAIL_PATTERN).nullable(),
    billingPhone: z.string().regex(PHONE_PATTERN).nullable(),
})
    .strict();
//# sourceMappingURL=billing-info.schema.js.map